import React from "react";
import { useNavigate } from "react-router";
import { BASE_URL } from "../../../../static/constants";
import { useFormik } from "formik";
import * as Yup from "yup";

// Material Imports
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

// Import CSS
import "./index.css";
import { showErrorToast, showSuccessToast } from "utils/toast";
import SubmitButton from "components/Button/SubmitButton";
import ModalContainer from "components/common/modals/modalContainer/ModalContainer";

export default function ChangePasswordModal(props) {
  const { passwordModalOpen, closePasswordModal } = props;
  const navigate = useNavigate();

  const onClose = () => {
    formik.resetForm();
    closePasswordModal();
  };

  const sendForgotPassword = (values) => {
    fetch(`${BASE_URL}/v2/user/forgot-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: values.emailAddress,
      }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.error) {
          throw Error(response.message);
        }
        formik.setFieldValue("emailSent", true);
        showSuccessToast(response.message);
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (
          errorStr === "Error: jwt malformed" ||
          errorStr === "Error: jwt expired"
        ) {
          navigate("/login");
        } else if (errorStr === "Error: Unauthorized") {
          navigate("/prohibited");
        }
        showErrorToast(errorStr);
      });
  };

  const formik = useFormik({
    initialValues: {
      emailAddress: "",
      emailSent: false,
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .email("Invalid email address")
        .required("Email is Required"),
    }),
    onSubmit: (values) => {
      sendForgotPassword(values);
    },
  });

  return (
    <div>
      <ModalContainer
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        show={passwordModalOpen}
        onClose={onClose}
        title={formik.values.emailSent ? "Email Sent" : "Account Recovery"}
        onRendered={formik.resetForm}
      >
        {!formik.values.emailSent && (
          <div>
            <div style={{ marginTop: 10 }}>
              Enter your email address and we will send you a password recovery
              link.
            </div>
          </div>
        )}
        {formik.values.emailSent && (
          <div>
            <div style={{ marginTop: 10 }}>
              Reset password link has been sent to the email, if the given email
              exists in our system!
            </div>
          </div>
        )}
        {!formik.values.emailSent && (
          <form onSubmit={formik.handleSubmit}>
            <div style={{ marginBottom: "20px", marginTop: "20px" }}>
              <div style={{ position: "relative" }}>
                <TextField
                  id="emailAddress"
                  name="emailAddress"
                  label="Email Address"
                  type="text"
                  margin="none"
                  variant="outlined"
                  fullWidth
                  value={formik.values.emailAddress}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.emailAddress &&
                    Boolean(formik.errors.emailAddress)
                  }
                  helperText={
                    formik.touched.emailAddress && formik.errors.emailAddress
                  }
                />
              </div>
            </div>
            <div className="view-pdf__button-container" style={{ gap: "10px" }}>
              <Button onClick={onClose} variant="outlined" color="secondary">
                Cancel
              </Button>
              <SubmitButton
                handleClick={formik.handleSubmit}
                disabled={formik.isSubmitting}
                buttonText="Send Forgot Password Link"
              />
            </div>
          </form>
        )}
        {formik.values.emailSent && (
          <div style={{ marginTop: 40 }}>
            <div className="view-pdf__button-container">
              <Button onClick={onClose} variant="outlined" color="secondary">
                Close
              </Button>
            </div>
          </div>
        )}
      </ModalContainer>
    </div>
  );
}
